import React, { useContext, useEffect, useState } from "react";
import { Grid, Button, Typography } from "@material-ui/core";
import { confirmSetUp2FA, get2FAConfig } from "../api/AuthAPI";
import ValidatedInput, { InputRef } from "../components/ValidatedInput";
import { ErrorSnackbar, SuccessSnackbar } from "../components/Snackbars";
import translate from "../i18n/Translator";
import ExternSurface from "../components/ExternSurface";
import { RouterParams } from "../router/RouterParams";
import { DoubleFactorAuthenticationRequest, User } from "../model/User";
import { Code2FAValidator } from "../components/Validators";
import Progress from "../components/Progress";
import Surface from "../components/Surface";
import PhonelinkLockIcon from '@material-ui/icons/PhonelinkLock';
import parse from 'html-react-parser';
import { AppContext } from "../context/AppContext";

export default function SetUpUserTwoFA({ match }: RouterParams) {
    const context = useContext(AppContext);

    const [submitting, setSubmitting] = useState(false);
    const [message, setMessage] = useState<string>("<div></div>");
    const code2FAValidator = new Code2FAValidator();
    const [error, setError] = useState("");
    const [succcess, setSuccess] = useState("");
    const [user, setUser] = useState<User>();
    const [request, setRequest] = useState<DoubleFactorAuthenticationRequest>({
        code: "",
    } as DoubleFactorAuthenticationRequest);
    const [validations, setValidations] = useState({
        "code": {
            valid: false
        } as InputRef,
    } as any);

    useEffect(() => {
        get2FAConfig(match.params.code).then((response) => {
            setMessage(translate("users.security.uset_setup_2fa", { "secret": response!.secret_2fa }) as string);
            setUser(response);
        }).catch((error) => {
            setError(error.message);
        });
    }, [match.params.code]);

    const hasChanged = (name: string, value: string, inputRef: InputRef) => {
        setRequest({ ...request, [name]: value });

        validations[name] = inputRef;
        setValidations(validations);
    };

    const isValid = () => {
        var valid = true;
        for (let field in validations) {
            let ref = validations[field];
            if (!ref.valid) {
                ref.blurer(true);
                valid = false;
            }
        }
        return valid;
    }

    const onSubmit = (event: React.FormEvent<HTMLFormElement>) => {
        event.preventDefault();
        if (!isValid()) {
            return;
        }

        setSubmitting(true);
        confirmSetUp2FA(match.params.code, request).then((_) => {
            setSuccess(translate("users.security.confirmed_2fa") as string);
            context.onSignedIn();
        }).catch((_) => {
            setError(translate("users.security.invalid_setup_2fa") as string);
        }).finally(() => {
            setSubmitting(false);
        });
    }

    const onClosedSnackbar = () => {
        setError("");
        setSuccess("");
    };


    if (!user) {
        return (<Progress />);
    }

    return (
        <ExternSurface title={translate("auth.recover.title") as string} xl={6} lg={6}>
            <Surface title={translate("users.security.2fa") as string} icon={<PhonelinkLockIcon />}>
                <form autoComplete="off" noValidate onSubmit={onSubmit} >
                    <Grid item xs={12}>
                        <Grid container spacing={3} alignItems="flex-start" alignContent="center" justify="center">
                            <Grid item xs="auto">
                                <img src={user.qr_url_2fa!} alt="2FA QR"></img>
                            </Grid>
                            <Grid item xs={12} md>
                                <Typography variant="caption">
                                    {parse(message)}
                                </Typography>
                                <Grid container alignItems="center" alignContent="center" justify="center">
                                    <Grid item xs={12}>
                                        <ValidatedInput type="text" id="code" name="code" value={request?.code}
                                            label={translate("users.2fa_code") as string} maxLength={6}
                                            onValueChanged={hasChanged} disabled={submitting}
                                            required validator={code2FAValidator}
                                            margin={"dense"} />
                                    </Grid>
                                    <Grid item xs={12} className="ExternButton">
                                        <Button type="submit" variant="contained" color="primary" fullWidth size="large" disabled={submitting}>
                                            {translate("users.security.buttons.enable_2fa")}
                                        </Button>
                                    </Grid>

                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>
                </form>
                <ErrorSnackbar message={error} onClose={onClosedSnackbar} />
                <SuccessSnackbar message={succcess} onClose={onClosedSnackbar} />
            </Surface>

        </ExternSurface >
    );

}
